import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Footer from "../navigation/Footer";
import Header from "../navigation/Header";

const HeaderFooterLayout = () => {
  return (
    <>
      <Header />
      <Box component="main">
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

export default HeaderFooterLayout;
